import $ from 'jquery'
import {Core} from "./core.js";

export class Chatbot {
  constructor () {
    this.$body = $('body')
    this.$window = $(window)
    this.$button = $('#cegid-chatbot-button')
    this.$iframe = $('#cegid-chatbot')

    this.$button.on('click', this.handleClick.bind(this))
  }

  handleClick (e) {
    e.preventDefault()
    this.$iframe.toggleClass('active')
  }
}
